module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "bleeding-red"
    }
  }, [_c('h1', [_vm._v("Bleeding Red")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("It is said that African soil is so red,")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("From all the battles of civil war.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("It is stained from all the bloodshed,")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Its heart ripped from its core.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("African beauty cannot be explained,")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("The sun, the bush and sea.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Its blood runs through our veins,")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Calling you back it will always be.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("The African wind is now weeping,")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("The animals are being murdered.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("The silver lining disappearing,")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Its people being slaughtered.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("An African elephant named,")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("By the shape of her continental ear.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Wildlife roam free and untamed,")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Not for long, as they slowly disappear.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("The pain she feels as man has neglected,")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("The generosity of her lands.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("She is a gentle soul being rejected,")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("By the greed of outstretched hands.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("There is hope for her future generations,")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Our children can hear a lion’s roar!")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Only if we start now with preparations,")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Stitching back what we have tore.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Understanding the African lure,")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Can only be felt by those born there.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("It is wild, perfect, pure,")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Although it seems that some don’t care.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("I fear for Africa, divided by poverty,")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Made possible by her political leaders.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("There is no longer solidarity,")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Between the battling soldiers.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Africa quivers as war rages on,")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Unnecessary hate in the breeze.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Her tears continue to rain upon,")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Her ground that is red, it still bleeds!")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_c('strong', [_c('br')])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-476c534a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch011.vue
// module id = 93
// module chunks = 0